export default {
  headerContent: {
    title: 'Türk Nippon (DASK) Zorunlu Deprem Sigortası Prim Hesaplama',
    slogan: "Zorunlu Deprem Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'DASK TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türk Nippon Sigorta DASK',
    description: {
      title:
        'Türk Nippon Sigorta DASK (Zorunlu Deprem Sigortası) Nedir? DASK Ne Demek? ',
      content: [
        'Türk Nippon Sigorta zorunlu deprem sigortası deprem sonucunda konutun yıkılması veya yangın, infilak gibi zararları poliçe limitleri dahilinde güvence altına almaktadır.'
      ]
    },
    subContent: {
      title: 'Türk Nippon Sigorta Zorunlu Deprem Sigortası Teminatları Neler?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası teminatları;',
          subList: [
            'Deprem sonrası maddi zarar,',
            'Deprem sonrası yangın,',
            'Deprem sonrası infilak,',
            'Deprem sonrası tsunami,',
            'Deprem sonrası yer kayması teminatından oluşmaktadır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'DASK Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'DASK Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'DASK Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Turk Nippon Sigorta DASK Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
